@if (icon()) {
  <div class="bg-background-primary-alt rounded-full p-4">
    <tui-icon class="text-text-placeholder size-8" [icon]="icon()" />
  </div>
}
<div class="flex flex-col gap-2">
  <p class="font-medium text-text-tertiary">{{ title() }}</p>
  @if (description()) {
    <p class="text-xs text-text-placeholder">{{ description() }}</p>
  }
</div>
<ng-content />
